export default __webpack_public_path__ + "0421d4de0806f1e21cb028150c4f86a4.png";